import React, { useState, useEffect } from 'react';
import axios from 'axios';
import uuidv4 from 'uuid/v4';
import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from './Button';
import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { i18n } from '../App';

import postJson from '../coolfoodSync';

const useStyles = makeStyles(theme => {
  return {
    root: {
      overflow: 'hidden'
    },
    intro: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    stepTitle: theme.stepTitle,
    grid: {
      marginTop: '50px',
      paddingRight: '20px'
    },
    buttons: {
      ...theme.buttons,
      marginTop: theme.spacing(5)
    },
    checkboxEmails: {
      marginTop: 5
    },
    checkboxNewsletter: {
      marginTop: -10
    },
    required: {
      borderColor: '#ff00ee'
    },
    allowContact: {
      fontWeight: 400
    },
    exists: {
      marginTop: theme.spacing(4),
      color: theme.pink,
      fonSize: '1.2em',
      fontWeight: 400
    },
    duplicates: {
      marginTop: theme.spacing(4),
      color: theme.pink,
      fonSize: '1.2em',
      fontWeight: 400
    }
  };
});

export default function CommitProcess() {
  const [globalState, globalDispatch] = useCoolfoodContext();
  const [emailValid, setEmailValid] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [duplicates, setDuplicates] = useState(false);

  const classes = useStyles();

  // When displayint the screen, make the girl talk
  useEffect(() => {
    globalDispatch({
      type: actions.SHOW_HELP,
      content: i18n._(
        'Laissez votre email si vous souhaitez disposer d\'un suivi personnalisé'
      )
    });
  }, [globalDispatch]);

  // Make the girl explains why we need an email
  useEffect(() => {
    if (!emailValid && !formValid) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._(
          'Indiquez un mot de passe afin d\'accéder à votre espace personnel. Vous pourrez le changer par la suite si besoin'
        )
      });
    }
  }, [emailValid, formValid, globalDispatch]);
  // User with email already exists
  useEffect(() => {
    if (globalState.coolfooder.exists) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._(
          'Cet adresse email est déjà utilisée, si vous en êtes le propriétaire, vous pouvez passer à l\'étape suivante, sinon indiquez en une autre.'
        )
      });
    }
  }, [globalDispatch, globalState.coolfooder.exists]);

  useEffect(() => {
    if (
      globalState.coolfooder.password !== globalState.coolfooder.passwordConfirm
    ) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._('Les mots de passe ne correspondent pas')
      });
    }
  }, [
    globalDispatch,
    globalState.coolfooder.password,
    globalState.coolfooder.passwordConfirm
  ]);

  // Make girl says when passwords mismatch

  // If email is valid, check if user already exists and so show a message and disable already taken commits
  useEffect(() => {
    if (emailValid) {
      axios
        .get(
          `/wp-json/coolfood/v1/coolfooder_commits_by_email/${
            globalState.coolfooder.email
          }`
        )
        .then(response => {
          // We got some ids
          if (response && response.data) {
            const commitsAlreadyTaken = response.data.commits;
            const exists = response.data.user_exists;
            // Set if user found
            globalDispatch({
              type: actions.SET_COOLFOODER_INFOS,
              infos: { exists }
            });
            // Compare them with taken commits today
            let duplicates = [];
            if (commitsAlreadyTaken.length > 0) {
              duplicates = commitsAlreadyTaken.filter(x =>
                globalState.selectedCommitments.includes(x)
              );
            }
            if (duplicates.length > 0) {
              setDuplicates(true);
            }
          }
        });
    }
  }, [
    emailValid,
    globalDispatch,
    globalState.coolfooder.email,
    globalState.selectedCommitments
  ]);

  // Message displayed when the form is complete
  useEffect(() => {
    if (formValid) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._(
          'Promis, nous ne vous enverrons pas plus d\'emails que nécessaire.'
        )
      });
    }
  }, [formValid, globalDispatch, globalState.coolfooder.email]);

  // Validate the whole form
  useEffect(() => {
    let status = true;
    if (!globalState.coolfooder.firstname) {
      status = false;
    }
    if (
      !globalState.coolfooder.email ||
      (globalState.coolfooder.email && !emailValid)
    ) {
      status = false;
    }
    if (
      !globalState.coolfooder.password ||
      globalState.coolfooder.password !== globalState.coolfooder.passwordConfirm
    ) {
      status = false;
    }
    setFormValid(status);
  }, [
    emailValid,
    globalState.coolfooder.email,
    globalState.coolfooder.firstname,
    globalState.coolfooder.password,
    globalState.coolfooder.passwordConfirm
  ]);

  // If email is invalid, update local state
  useEffect(() => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setEmailValid(re.test(String(globalState.coolfooder.email).toLowerCase()));
  }, [globalState.coolfooder.email]);

  const setCoolfooderInfos = e => {
    globalDispatch({
      type: actions.SET_COOLFOODER_INFOS,
      infos: {
        [e.target.name]:
          e.target.type === 'text' ? e.target.value : e.target.checked
      }
    });
  };

  const postForm = () => {
    sendDatasToServer();
    globalDispatch({ type: actions.NEXT_SLIDE });
  };

  const sendDatasToServer = () => {
    const {
      uuid,
      firstname,
      lastname,
      email,
      phone,
      postalCode,
      allowContactFromCoolfood,
      subscribeToNewsletter,
      password
    } = globalState.coolfooder;

    const user_auth_hash = uuidv4();

    const datas = {
      id_happening: globalState.happening.happening.id,
      user_uuid: uuid,
      user_login: `${firstname}.${lastname}`,
      user_email: email,
      first_name: firstname,
      last_name: lastname,
      user_phone: phone,
      user_postalcode: postalCode,
      coolfooder_contact_from_coolfood: allowContactFromCoolfood,
      coolfooder_subscribe_to_newsletter: subscribeToNewsletter,
      user_pass: password,
      user_auth_hash
    };

    postJson({
      action: 'ADD_USER',
      data: datas,
      ts_disabled: null
    });

    globalDispatch({
      type: actions.SET_COOLFOODER_INFOS,
      infos: {
        auth_hash: user_auth_hash
      }
    });
  };

  return (
    <Container fixed className={`coolfooderInfos ${classes.root}`}>
      <div className={classes.intro}>
        {i18n._('Phrase explicative follow up')}
      </div>
      <form noValidate autoComplete="off">
        <Typography className={`ribbon ${classes.stepTitle}`}>
          {i18n._('Dernière étape : Indiquez vos coordonnées')}
        </Typography>
        <Grid container spacing={2} className={classes.grid}>
          {!globalState.coolfooder.exists && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={i18n._('Prénom')}
                  onChange={setCoolfooderInfos}
                  name="firstname"
                  variant="outlined"
                  value={globalState.coolfooder.firstname}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={i18n._('Nom')}
                  onChange={setCoolfooderInfos}
                  name="lastname"
                  value={globalState.coolfooder.lastname}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <TextField
              label={i18n._('Email')}
              onChange={setCoolfooderInfos}
              name="email"
              variant="outlined"
              value={globalState.coolfooder.email}
              fullWidth
              required
              error={!!globalState.coolfooder.email && !emailValid}
              helperText={i18n._(
                'J\'accepte de recevoir le programme d\'accompagnement hebdomadaire et sur 6 semaines'
              )}
            />
          </Grid>
          {!globalState.coolfooder.exists && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  className={classes.required}
                  label={i18n._('Mot de passe')}
                  onChange={setCoolfooderInfos}
                  name="password"
                  variant="outlined"
                  value={globalState.coolfooder.password}
                  disabled={!emailValid}
                  autoComplete="current-password"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={i18n._('Répétez le mot de passe')}
                  onChange={setCoolfooderInfos}
                  name="passwordConfirm"
                  variant="outlined"
                  value={globalState.coolfooder.passwordConfirm}
                  disabled={!emailValid}
                  fullWidth
                  autoComplete="current-password"
                  error={
                    globalState.coolfooder.password !==
                    globalState.coolfooder.passwordConfirm
                  }
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={i18n._('Téléphone')}
                  onChange={setCoolfooderInfos}
                  name="phone"
                  variant="outlined"
                  value={globalState.coolfooder.phone}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={i18n._('Code postal')}
                  onChange={setCoolfooderInfos}
                  name="postalCode"
                  variant="outlined"
                  value={globalState.coolfooder.postalCode}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <div className={classes.allowContact} />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  label={i18n._(
                    'J\'accepte de recevoir les newsletters mensuelles du programme Cool Food'
                  )}
                  onChange={setCoolfooderInfos}
                  name="subscribeToNewsletter"
                  checked={
                    globalState.coolfooder.subscribeToNewsletter === true
                  }
                  control={<Checkbox />}
                  className={classes.checkboxEmails}
                  disabled={!emailValid}
                />
              </Grid>
            </>
          )}
          {globalState.coolfooder.exists && (
            <>
              <div className={classes.exists}>
                {i18n._(
                  'Un utilisateur existe déjà avec cette adresse email. De ce fait les engagements pris seront rattachés au compte existant.'
                )}
              </div>
            </>
          )}
          {duplicates && (
            <>
              <div className={classes.exists}>
                {i18n._(
                  'Vous êtes déjà inscrit sur Cool Food et avez déjà choisi certains des engagements sélectionnés aujourd\'hui. Retrouvez toutes ces informations dans votre espace personnel.'
                )}
              </div>
            </>
          )}
          <Grid item xs={12} className={classes.buttons}>
            <Button
              color="primary"
              disabled={!formValid && !globalState.coolfooder.exists}
              className="nextButton"
              variant="contained"
              onClick={postForm}
            >
              {i18n._('Suivant')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
